import ApiService from './ApiService';
import AuthService from './AuthService';
import LangService from '../LangService';

class GeoService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = LangService.getDefaultLocale();
        this._geoListUrl = '/geo';
        this._geoChildrenSettlementsUrl = '/geo/children-settlements';
        this._geoSearchUrl = '/geo/search';
        this._regionSingleUrl = '/geo/region-by-alias';
        this._regionsLinksUrl = '/geo/regions-links';
        this._regionsListUrl = '/geo/regions-products-count-list'
    }

    getBaseHeaders() {
        const langHeader = this.getLangHeader();
        const authHeader = this.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getAuthHeader(){
        this._authService.getAuthHeader();
    }

    getLangHeader() {
        return this._locale ? {'X-Localization' : this._locale} : {};
    }

    getApiService(){
        return this.getAuthService().getApiService();
    }

    getAuthService() {
        return this._authService;
    }

    getRegionsList() {
        return this.postResource(this._regionsListUrl, {}, this.getLangHeader())
    }

    setLocale(locale) {
        this._locale = locale;
    }

    async getRegionByAlias(alias) {
        return await this.postResource(
            this._regionSingleUrl,
            {alias},
            this.getLangHeader()
        );
    }

    async getChildrenSettlements(id) {
        return await this.postResource(
            this._geoChildrenSettlementsUrl,
            {id},
            this.getLangHeader()
        );
    }

    async getRegionsLinks() {
        return await this.postResource(
            this._regionsLinksUrl,
            {},
            this.getLangHeader()
        );
    }

    async getGeoList() {
        return await this.postResource(
            this._geoListUrl,
            {},
            this.getLangHeader()
        );
    }

    async getGeoSearch(val, parentId) {
        const params = { name: val };

        if(parentId) {
            params.parentId = parentId
        }

        return await this.postResource(
            this._geoSearchUrl,
            params,
            this.getLangHeader()
        );
    }
}

const geoService = new GeoService(AuthService);

export default geoService;
